import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from './utils';

export const api = createApi({
  baseQuery: baseQuery(),
  endpoints: () => ({}),
});
